import React, { Fragment } from 'react'
import SignIn from '../components/SignIn'
import ContentWrapper from '../components/ContentWrapper'

const SignInView = () => (
  <Fragment>
    {/* TODO: Compact Header Here */}
    <ContentWrapper>
      <div className="row justify-content-md-center">
        <div className="col col-md-5 col-lg-4">
          <h1 className="display-4">Sign In</h1>
          <SignIn />
        </div>
      </div>
    </ContentWrapper>
  </Fragment>
)

export default SignInView
